const BottomArc = () => {
  return (
    <svg
      width="100%"
      height="auto"
      viewBox="0 0 1280 269"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="bg-white"
    >
      <path
        d="M-80 1.27136C127.878 133.288 374.509 209.745 639 209.745C904.339 209.745 1151.7 132.798 1360 0L1360 268.745L-80 268.745L-80 1.27136Z"
        fill="black"
      />
    </svg>
  )
}

export default BottomArc
